import {
  IFeedbacksReduxState,
  IGetFeedbackListAction,
  IGetFeedbackListActionFulfilled,
  IGetFeedbackListActionRejected
} from "../../types";

const initialState: IFeedbacksReduxState = {
  completed: false,
  data: {
    active: [],
    history: []
  },
  pending: false,
  rejected: false
};

type Action = IGetFeedbackListAction | IGetFeedbackListActionFulfilled | IGetFeedbackListActionRejected;

export default (state = initialState, action: Action): IFeedbacksReduxState => {
  switch (action.type) {
    case "GET_FEEDBACK_LIST":
      return {
        ...state,
        completed: false,
        data: {
          active: [],
          history: []
        },
        pending: true,
        rejected: false
      };
    case "GET_FEEDBACK_LIST_FULFILLED":
      return {
        ...state,
        completed: true,
        data: action.payload,
        pending: false,
        rejected: false
      };
    case "GET_FEEDBACK_LIST_REJECTED":
      return {
        ...state,
        completed: true,
        data: {
          active: [],
          history: []
        },
        pending: false,
        rejected: true
      };
    default:
      return state;
  }
};
